import { Link } from "react-router-dom";
import { getImageUrl } from "./ProductCard";

export function PromoCardsRow({ section }) {
  const cards = section.offerCards || [];
  if (!cards.length) return null;

  return (
    <section className="container mx-auto px-4 lg:px-8 py-6">
      {section.title && (
        <h2 className="text-2xl font-display font-bold mb-6 sr-only text-foreground">
          {section.title}
        </h2>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
        {cards.map((card, idx) => {
          const content = (
            <div className="relative flex items-center justify-between rounded-2xl bg-surface border border-border overflow-hidden min-h-[160px] p-5 lg:p-6 group hover:-translate-y-1 hover:border-primary/40 hover:shadow-card-hover transition-all">
              {card.image && (
                <img
                  src={getImageUrl(card.image)}
                  alt={card.title}
                  className="absolute right-0 bottom-0 h-full max-h-[140px] w-auto object-contain opacity-90 group-hover:scale-105 transition-transform"
                  loading="lazy"
                />
              )}
              <div className="relative z-10 max-w-[60%]">
                {card.eyebrow && (
                  <span className="inline-block px-2 py-0.5 text-[10px] font-bold uppercase bg-destructive text-destructive-foreground rounded mb-2">
                    {card.eyebrow}
                  </span>
                )}
                <h3 className="text-xl font-bold text-foreground">{card.title}</h3>
                {card.description && (
                  <p className="text-sm text-muted-foreground mt-1">{card.description}</p>
                )}
              </div>
            </div>
          );

          if (card.ctaLink) {
            const isExternal = card.ctaLink.startsWith("http");
            return isExternal ? (
              <a key={idx} href={card.ctaLink} target="_blank" rel="noopener noreferrer">
                {content}
              </a>
            ) : (
              <Link key={idx} to={card.ctaLink}>
                {content}
              </Link>
            );
          }
          return <div key={idx}>{content}</div>;
        })}
      </div>
    </section>
  );
}
